var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodeCrafter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 60,
    viewBox: "0 0 67 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 5.81667H5.81667V6.66667V53.3333V54.1833H6.66667H60H60.85V53.3333V6.66667V5.81667H60H6.66667ZM25.8873 30.6011L26.4883 30L25.8873 29.399L15.512 19.0236L19.024 15.5116L33.5121 30L19.024 44.4881L15.512 40.976L25.8873 30.6011ZM0.85 56.3146V3.68542L3.68542 0.85H62.9813L65.8167 3.68542V56.3146L62.9813 59.15H3.68542L0.85 56.3146ZM49.15 40.85V45.8167H34.1833V40.85H49.15Z",
    fill: "#323232",
    stroke: "#BAB7C5",
    strokeWidth: 1.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeCrafter);
export default __webpack_public_path__ + "static/media/code_crafter.bd6dd50a18b55e4631b7278cd925fe41.svg";
export { ForwardRef as ReactComponent };